import { render, staticRenderFns } from "./ProgressGroupItem.vue?vue&type=template&id=4382ff5b"
import script from "./ProgressGroupItem.vue?vue&type=script&lang=js"
export * from "./ProgressGroupItem.vue?vue&type=script&lang=js"
import style0 from "./ProgressGroupItem.vue?vue&type=style&index=0&id=4382ff5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports